import { defineSchema } from '../../schema-meta.ts';
import { registerCategorySchema } from '../../registry.ts';
import { SUMMON_TYPE } from '../../enum-registry.ts';

export const PetSummonConfigSchema = defineSchema({
  name: 'serverPetSummonConfigs',
  fields: [
    ['id', 'string'],
    ['summonType', { kind: 'enum', name: 'SummonType', members: SUMMON_TYPE }],
    ['summonCount', 'number'],
    ['cost', { kind: 'dict', dict: 'delivery' }],
  ],
  lookupKeys: ['id'],
});

export interface RawPetSummonConfigRow {
  id: string;
  summon_type: 'STANDARD' | 'PREVIEW';
  summon_count: number;
  cost: Record<string, number>;
}

export function petSummonConfigFromRaw(row: RawPetSummonConfigRow) {
  return {
    id: row.id,
    summonType: row.summon_type,
    summonCount: row.summon_count,
    cost: row.cost,
  };
}

registerCategorySchema('serverPetSummonConfigs', PetSummonConfigSchema);
